import React, { useEffect, useState } from 'react';
import { MenuItem } from '@material-ui/core';
import {
  Language,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from '@material-ui/icons';
import * as lib from '~/dependencies';
import * as locales from '~/i18n/locales';
import { Container, Menu, Button } from './styles';

const countries = Object.values(locales).map(e => {
  return {
    lang: e.lang,
    languageName: e.languageName,
  };
});

export default function IdiomSelector({ currentLang }) {
  // STATES
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState();
  const [localCurrLang, setLocalCurrLang] = useState(currentLang);
  const [availableCountries, setAvailableCountries] = useState([]);

  // CONST
  const i18nRefLng = process.env.REACT_APP_LOCIZE_REFLNG || 'en';

  // HOOKS
  const { i18n } = lib.useTranslation();

  // EFFECTS
  useEffect(() => {
    if (localCurrLang) {
      const countrySelected = countries.filter(e => e.lang === localCurrLang);
      const countryList = countries.filter(e => e.lang !== localCurrLang);

      if (countrySelected.length < 1) {
        const defaultCountry = countries.filter(e => e.lang === i18nRefLng);
        const defaultCountryList = countries.filter(e => e.lang !== i18nRefLng);
        setSelectedCountry(defaultCountry[0]);
        setAvailableCountries(defaultCountryList);
      } else {
        setSelectedCountry(countrySelected[0]);
        setAvailableCountries(countryList);
      }
    }
  }, [i18nRefLng, localCurrLang]);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleChangeLang(lang) {
    setLocalCurrLang(lang);
    setAnchorEl(null);
    i18n.changeLanguage(lang);
  }

  return (
    <Container>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        data-test-id="btn-idiom-selector"
        onClick={handleClick}>
        <Language />
        <span>{selectedCountry?.languageName}</span>
        {anchorEl !== null ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}>
        {availableCountries.map(e => (
          <MenuItem onClick={() => handleChangeLang(e.lang)} key={e.lang}>
            {e.languageName}
          </MenuItem>
        ))}
      </Menu>
    </Container>
  );
}

IdiomSelector.defaultProps = {
  currentLang: 'en',
};

IdiomSelector.propTypes = {
  currentLang: lib.PropTypes.string,
};
